export enum OpenBankingConnectionError {
  EmailBounced = 'https://errors.shine.co/open-banking-service-api/EMAIL_BOUNCED',
}
